import {DDR} from './ddr.class';

export class DDRWoman70Strategy extends DDR {
  constructor() {
    super([700, 15, 15, 75, 65, 1, 1, 14, 1.3, 400, 2.4, 5, 30, 425, 1200, 20, 900, 3, 150, 8, 320, 1.8, 700, 55, 8]);
  }
}
